<template>
  <div :class="$style.container">
    <Head />
    <Grid
      :class="$style.grid"
      :hasGap="false"
    >
      <GridItem
        :class="$style.gridFormWrap"
        :gridSpan="12"
      >
        <DeletedOrgBanner />
        <OnePageForm
          :isMsp="isMsp"
        />
      </GridItem>
    </Grid>
    <CookieBanner />
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
} from '@jumpcloud/ui-components';
import CookieBanner from 'client/signup/components/CookieBanner.vue';
import DeletedOrgBanner from 'client/signup/components/DeletedOrgBanner.vue';
import Head from 'client/signup/components/Head.vue';
import OnePageForm from 'client/signup/AdminSignup/OnePageForm.vue';

export default {
  name: 'SignupContainer',

  components: {
    CookieBanner,
    DeletedOrgBanner,
    Grid,
    GridItem,
    Head,
    OnePageForm,
  },

  props: {
    isMsp: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style module scoped>
  @value (max-width-medium) from '~css/breakpoints.css';

  .container {
    background-image: var(--static-admin-portal-bg-img);
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: none;
    display: flex;
    margin: 0 auto;
    min-height: 100vh;
    padding: var(--jc-spacer-medium);
  }

  .container::after {
    background: var(--jc-scrim-background);
    bottom: 0;
    content: '';
    display: flex;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
  }

  .gridFormWrap {
    background: var(--jcWhite50);
  }

  .grid {
    border-radius: 1rem;
    box-shadow: var(--jc-box-shadow-card);
    margin: auto;
    max-width: 60rem;
    overflow: hidden;
    z-index: 1;
  }

  @media (max-width: max-width-medium) {
    .container {
      height: 100%;
      padding: 0;
    }

    .grid {
      border-radius: 0;
      box-shadow: none;
      height: 100%;
      margin: 0;
      max-width: none;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
</style>
